/**
 * AddChannelCtrl controller
 * Add/edit channels
 */

import { PLATFORM_TYPES, DRM_ACCOUNT_TYPES, URL_PATTERN, RESOLUTIONS } from 'app/core/constants'
import { getId } from 'app/helpers/entity'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

// controller mixins
AddChannelCtrl.mixes = [
  ['m2mCtrlMixin', 'chnl', 'networks']
]

/**
 * AddChannelCtrl controller
 *
 * @class AddChannelCtrl
 * @memberof mwApp/channels
 * @see mwApp/channels
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/channels.controller:AddChannelCtrl
 */
/* @ngInject */
export default function AddChannelCtrl ($timeout, $state, $scope, $transition$, $location, ChannelDTO, ChannelSet, Network, UrlPolicy, chnl, serviceExtra, scope, authSvc, storageSvc, alertLiteSvc, extra, allNetworksById, alertSvc) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', '', 'services']]
  Object.assign(vm, extra)

  vm.urlPattern = URL_PATTERN
  vm.resolutions = authSvc.hasEnabledFlag('FEATURE_DOLBY_4K_ENABLED') ? RESOLUTIONS : ['SD', 'HD']

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  // $scope.loading = true

  /**
   * serviceExtra response
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {Object|null}
   */
  vm.serviceExtra = serviceExtra

  /**
   * DRM account types
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * isNew flag
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {Boolean}
   */
  vm.isNew = chnl._isNew()

  if (!vm.isNew) {
    chnl.contentSets.forEach(cs => { cs.networkName = allNetworksById[cs.networkId]?.name })
  }

  /**
   * Channel
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {models.Channel}
   */
  vm.chnl = scope.chnl = chnl

  if (!vm.isNew && chnl.networks.length === 0) {
    vm.networkSelected = { id: 0, name: 'All Organizations' }
  }

  /**
   * Set default channel type for new channel
   */
  if (vm.isNew) {
    vm.chnl.channelType = 'TV'
  }

  vm.ageRatings = JSON.parse(storageSvc.local.get('ageRatings'))
  vm.countries = JSON.parse(storageSvc.local.get('countries'))

  if (!vm.isNew && chnl.ageRating) {
    if (vm.chnl.$ageRatingType === 'default') {
      vm.chnl.$defaultAgeRating = vm.ageRatings.defaultAgeRatings.find(r => r.id === chnl.$defaultAgeRating.id)
      vm.chnl.ageRating = null
    } else {
      vm.chnl.$country = vm.countries.find(c => c.id === chnl.$country.id)
      const country = vm.ageRatings.customAgeRatings.find(c => c.id === chnl.$country.id)
      vm.chnl.ageRating = country.ageRatings.find(r => r.id === vm.chnl.ageRating.id)
      vm.chnl.$defaultAgeRating = null
    }
  }

  vm.getRating = function () {
    if (vm.chnl.$ageRatingType === 'default') {
      return vm.ageRatings.defaultAgeRatings
    } else {
      if (vm.chnl.$country) {
        return vm.ageRatings.customAgeRatings.find(r => r.id === vm.chnl.$country.id).ageRatings
      }
    }
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Platform types
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {Object[]}
   */
  vm.platformTypes = angular.copy(PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }))

  /**
   * DRM profiles
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {String[]}
   */
  vm.drmProfiles = []

  /**
   * Has access channel constant
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @function
   */
  vm.hasAccess = (access) => authSvc.hasAccess(access)

  /**
   * Upload logo
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @function
   */
  vm.uploadLogo = (file) => {
    if (window.URL) {
      vm.img = window.URL.createObjectURL(file)
    } else {
      const reader = new window.FileReader()
      reader.onload = function () {
        vm.img = reader.result
      }
      reader.readAsDataURL(file)
    }
    if (file.size > 10485760) {
      $scope.$broadcast('dndfile.clear', true)
      alertLiteSvc.alertError('File bigger than 10 MB')
      return
    }
    vm.logoPromise = new Promise((resolve, reject) => {
      const img = new window.Image()
      img.src = vm.img
      img.onload = function () {
        if (this.width < 500) {
          reject()
        }
        if (this.height < 294) {
          reject()
        }
        resolve()
      }
    })
    vm.logoPromise.then(() => {
      return chnl._uploadFile(null, file, {
        type: 'channel'
      }).then(
        response => {
          chnl.logoUrl = response.data
          $scope.$broadcast('dndfile.clear', true)
        }
      )
        .catch((err) => {
          if (!err.statusText) {
            alertLiteSvc.alert(`External API Error. Code: ${err.status}`, 'danger')
          } else {
            alertLiteSvc.alertError(err)
          }
          $scope.$broadcast('dndfile.clear', true)
        })
    })
      .catch(() => {
        alertLiteSvc.alert('Dimensions mismatch of uploaded image 500×294 and more', 'danger')
        $scope.$broadcast('dndfile.clear', true)
      })
    vm.form.$setDirty()
  }

  /**
   * Validate, if at least one platform is checked
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   */
  vm.atLeastOnePlatform = function () {
    for (var i = vm.platformTypes.length; i--;) {
      if (vm.platformTypes[i].checked) {
        return false
      }
    }
    return true
  }

  // save package catchupAllowed in order to check it later
  var originalCatchupAllowed = vm.chnl.type === 'TV' && authSvc.hasEnabledFlag('FEATURE_NORA_CATCHUPS_ALLOWED_ENABLED') ? true : vm.chnl.catchupAllowed

  // fix Channel field values
  chnl.urls = chnl.urls || {}

  // load extra data for channel, like languages, extansions
  const data = extra
  angular.extend(vm, data)
  vm.listOfNetworks = angular.copy(data.networks)
  if (!vm.isNew && chnl.networks.length === 0) {
    chnl.networks = data.networks
    vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
  } else {
    const existingNetworks = chnl.networks.map(getId)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(data.networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
      .filter(n => existingNetworks.indexOf(n.id) === -1)
  }
  vm.drmProfiles = data.drmProfiles
    .map(({ id, name, enabled, providerType, drmType }) => ({ id, name, enabled, providerType, drmType }))

  for (const prop in chnl.urls) {
    if (Object.prototype.hasOwnProperty.call(chnl.urls, prop)) {
      if (!chnl.urls[prop]) {
        continue
      }

      for (let i = 0; i < chnl.urls[prop].drmProfiles.length; i++) {
        const findProfile = vm.drmProfiles.find((dp) => dp.id === chnl.urls[prop].drmProfiles[i].id)

        if (findProfile) {
          chnl.urls[prop].drmProfiles[i] = angular.copy(findProfile)
        }
      }
    }
  }
  $scope.loading = false

  /**
   * Create/update Channel
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   */
  vm.save = function () {
    function doSave () {
      if (vm.chnl.type === 'TV' && authSvc.hasEnabledFlag('FEATURE_NORA_CATCHUPS_ALLOWED_ENABLED')) {
        chnl.catchupAllowed = true
      }

      vm.setDisable()

      chnl._save(ch => {
        if (ch.networks.length === vm.listOfNetworks.length) {
          ch.networks = []
        }
        return ch
      })
        .then(vm.location(chnl).reload)
        .then(
          () => {
            if (vm.isNew && authSvc.hasAccess('editChannel')) {
              ChannelDTO.loadAvailableContentSets(chnl)
                .then(data => {
                  if (data.length) {
                    alertSvc.confirm(`${chnl.name} Channel has added. <br> Do You want to assign this Channel to the Channel Set(s)?`)
                      .then(() => {
                        openAssignContentSets($state, $location, chnl, true)
                      })
                  }
                })
            }
          })
        .catch(vm.unsetDisable)
    }

    if (!vm.isNew && originalCatchupAllowed && !vm.chnl.catchupAllowed) {
      alertSvc.confirm('You\'ve unchecked "Catch Up Allowed" property, all catchups (if any) will be lost, are you sure?')
        .then(doSave)
    } else {
      doSave()
    }
  }

  /**
   * Delete Channel
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   */
  vm.delete = function () {
    vm.setDisable()

    chnl._delete()
      .then(vm.location(chnl).list)
      .finally(vm.unsetDisable)
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Find provider type by platformName from selected profiles
   * @param platformName
   * @returns {String|null}
   */
  vm.findSelectedProviderType = (platformName) => {
    const selectedProfile = vm.chnl?.urls[platformName]?.drmProfiles && vm.chnl.urls[platformName].drmProfiles[0]
    if (!selectedProfile) {
      return null
    }

    return selectedProfile.providerType
  }

  /**
   * Change drm profile callback function
   * @param {string} platformName
   * @returns {Function}
   */
  vm.changeDrmProfile = (platformName) => {
    if (!vm.chnl.urls[platformName].drmProfiles.length) {
      vm.chnl.urls[platformName].kek = null
    }
  }

  vm.stbUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webPlatformChecked = false
    if (webPlatform) {
      webPlatformChecked = webPlatform.checked
    }
    if (webPlatformChecked) {
      return false
    } else {
      return vm.urlAttention(url)
    }
  }

  vm.urlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  /**
   *  Filter networkSets according available networks
   * @param pckg
   * @returns {Function}
   */
  vm.deselectPckg = function (pckg) {
    vm.deselectNetwork(pckg, vm.form)
    if (vm.chnl.networks.length > 0) {
      vm.chnl.contentSets = vm.chnl.contentSets.filter(cs => cs.networkId !== pckg.id)
    } else {
      vm.networkSelected = null
    }
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
    vm.networks = vm.networks.filter(n => n.id !== -1)
  }

  vm.selectOrganization = function () {
    if (vm.networkSelected.id === 0) {
      vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      vm.chnl.networks = angular.copy(vm.listOfNetworks)
    } else if (vm.networkSelected.id === -1) {
      vm.chnl.networks = []
      vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.listOfNetworks)
      vm.networkSelected = null
    } else {
      vm.selectNetwork(vm.networkSelected)
      if (vm.networks.length === 1) {
        vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      }
    }
  }

  vm.showAllNetworks = false
  vm.showButton = function () {
    const container = document.getElementById('networks-container')
    return container.scrollHeight > 210
  }

  vm.toggleShowAllNetworks = function () {
    vm.showAllNetworks = !vm.showAllNetworks
  }

  /**
   * Filter for drm profiles
   * @param platformName
   * @returns {Function}
   */
  $scope.filterProfiles = function (platformName) {
    return function (profile) {
      if (!vm.chnl.urls[platformName] ||
        !vm.chnl.urls[platformName].drmProfiles ||
        !vm.chnl.urls[platformName].drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType(platformName)
      return profile.providerType === selectedProviderType && !vm.chnl.urls[platformName].drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * Delete Logo
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   */
  $scope.deleteLogo = function () {
    vm.form.$setDirty()
    vm.chnl.logoUrl = null
  }

  $scope.$watch('vm.chnl.networks.length', (cur, old) => {
    if (+cur === 1 && +old === 0) {
      vm.chnl.contentSets = vm.chnl.contentSets.filter(cs => cs.networkId === vm.chnl.networks[0].id)
    }
  })

  /**
   * If eq platform type
   *
   * @param name
   * @param type
   * @return {boolean}
   */
  vm.checkPlatform = function (name, type) {
    return vm.findSelectedProviderType(name) === type
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddChannelCtrl
   */
  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink(vm.chnl._publicListUrl)
  })

  $timeout(vm.unsetDisable)
}
